(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/video-analysis-button/assets/javascripts/video-analysis-button.js') >= 0) return;  svs.modules.push('/components/tipsen/video-analysis-button/assets/javascripts/video-analysis-button.js');
"use strict";


const {
  ReactIconButton: IconButton,
  ReactIcon: Icon
} = svs.ui;
const {
  clx
} = svs.components.lbUtils;
const SvgPlayIcon = () => React.createElement("svg", {
  className: "pg_video_analysis_button__play_icon",
  viewBox: "0 0 24 24"
}, React.createElement("rect", {
  fill: "none",
  height: "18.5",
  rx: "1",
  stroke: "currentColor",
  strokeWidth: "1.5",
  width: "22",
  x: "1",
  y: "2.75"
}), React.createElement("path", {
  d: "M10 9 L10 15 L15 12 Z",
  fill: "currentColor"
}));
const SvgSpinner = () => React.createElement("svg", {
  "aria-hidden": "true",
  className: "pg_video_analysis_button__spinner",
  height: "16",
  viewBox: "0 0 16 16",
  width: "16"
}, React.createElement("circle", {
  cx: "8",
  cy: "8",
  fill: "none",
  opacity: "0.5",
  r: "6",
  strokeWidth: "2"
}), React.createElement("path", {
  className: "svg-spinner",
  d: "M8 2 A6 6 0 0 1 14 8",
  fill: "none",
  strokeLinecap: "round",
  strokeWidth: "2"
}));
const BottomProgressBar = _ref => {
  let {
    progress
  } = _ref;
  return React.createElement("div", {
    "aria-hidden": "true",
    className: "pg_video_analysis_button__progress_container"
  }, React.createElement("div", {
    className: "pg_video_analysis_button__progress_bar",
    style: {
      width: "".concat(progress, "%")
    }
  }));
};
const VideoAnalysisButton = _ref2 => {
  let {
    ariaLabel,
    onClick,
    disabled,
    isPaused,
    isPending,
    isPlaying,
    progress,
    title
  } = _ref2;
  return React.createElement(IconButton, {
    "aria-label": ariaLabel,
    className: clx('pg_video_analysis_button', {
      'is-pending': isPending
    }),
    disabled: disabled,
    onClick: onClick,
    title: title
  }, isPending && React.createElement(SvgSpinner, null), !isPending && (isPlaying || isPaused) && React.createElement(Icon, {
    icon: "close",
    size: "300"
  }), !isPending && !isPlaying && !isPaused && React.createElement(SvgPlayIcon, null), React.createElement("span", null, "Videoanalys"), React.createElement(BottomProgressBar, {
    progress: progress
  }));
};
const VideoAnalysisButtonCircle = _ref3 => {
  let {
    ariaLabel,
    onClick,
    isPaused,
    isPending,
    isPlaying,
    disabled,
    progress,
    title
  } = _ref3;
  const radius = 14;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - progress / 100 * circumference;
  return React.createElement(IconButton, {
    "aria-label": ariaLabel,
    className: clx('pg_video_analysis_button--circle', {
      'has-progress': progress > 0
    }),
    disabled: disabled,
    onClick: onClick,
    title: title,
    type: "button"
  }, progress > 0 && React.createElement("svg", {
    className: "pg_video_analysis_button--circle__progress_ring",
    height: "30",
    width: "30"
  }, React.createElement("circle", {
    className: "pg_video_analysis_button--circle__progress_ring__circle",
    cx: "15",
    cy: "15",
    r: radius,
    strokeDasharray: "".concat(circumference, " ").concat(circumference),
    style: {
      strokeDashoffset
    }
  })), isPending && React.createElement(SvgSpinner, null), !isPending && React.createElement(Icon, {
    icon: isPlaying || isPaused ? 'close' : 'play'
  }));
};
setGlobal('svs.components.tipsen.videoAnalysisButton', {
  SvgPlayIcon,
  SvgSpinner,
  VideoAnalysisButton,
  VideoAnalysisButtonCircle
});

 })(window);